import { render, staticRenderFns } from "./ShipmentHandle.vue?vue&type=template&id=56695a0c&"
import script from "./ShipmentHandle.vue?vue&type=script&lang=js&"
export * from "./ShipmentHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports